module.exports = __webpack_public_path__ + "static/media/safe.21c52fb0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/InsufficientPopup/safe.svg
// module id = 2025
// module chunks = 103